import { BaseDto } from './base.dto';
import { ContractorNote } from './contractor-note.dto';

export class Contractor extends BaseDto {
  email?: string;
  name?: string;
  address?: string;
  phone?: string;
  jobTitle?: string;
  notes?: ContractorNote[];
  companyNumber?: string;
}
